import request from '@/http/request'
export const getUserList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/user/search`, { params })
}
export const getUserAdd = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/user/new`, params)
}
export const userUpdate = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/user/update`, params)
}
export const getUserDelete = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/user/delete?${params}`)
}
export const getRoleList = params => {
  // 未使用
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/user/roleList`, { params })
}
export const getSystemFactoryGroup = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/system/config/query/distinct`, params)
}
